import { $Q } from './querySelector';

const AUTO_HIDE_DELAY = 5000;
let autoHideTimeoutId = null;

/**
 * Auto-hides the cart notification banner after AUTO_HIDE_DELAY.
 * Any pending timeout is cleared first so consecutive notifications
 * each get a fresh 5s window instead of stacking.
 */
export function scheduleCartNotificationAutoHide(cartNotification) {
  if (!cartNotification) return;

  if (autoHideTimeoutId) clearTimeout(autoHideTimeoutId);

  autoHideTimeoutId = setTimeout(() => {
    cartNotification.classList.add('hidden');
    autoHideTimeoutId = null;
  }, AUTO_HIDE_DELAY);
}

/**
 * Show an error message in the global cart notification banner,
 * mirroring the pattern used by the API client on failed add-to-cart requests.
 */
export function showCartNotificationError(message) {
  const cartNotification = $Q('.cart-notification');
  const notificationContainer = $Q('.cart-notification__container');

  if (!cartNotification || !notificationContainer || !message) return;

  notificationContainer.innerHTML = `<span>${message}</span>`;
  cartNotification.classList.add('error');
  cartNotification.classList.remove('hidden');

  scheduleCartNotificationAutoHide(cartNotification);
}
